import axios from "axios";


export default axios.create({
    baseURL: `${globalThis._ENV_.REACT_APP_BASE_URL}`,
    headers: { 'Content-Type': 'application/json' },
})